import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { Alert, Row } from "@intech/web-ui";

export const SmallAlert = styled(Alert)`
  align-self: baseline;
  width: inherit;
`;

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
`;
